import React from "react";
import StoreProfileComp from "../../components/Store/StoreProfile";

export default function StoreProfile() {
  return <StoreProfileComp />;
}
